export default __webpack_public_path__ + "static/media/622.db012a99.png";